import { useEffect } from 'react'
import { Box } from '@mui/material'
import { useFormikContext } from 'formik'
import { t } from 'i18next'

import { SwitchField } from 'src/components/shared/ui/form/fields'
import { FormField } from 'src/enums/Form'
import { EscritosFormValues } from '../../types/escritosFormTypes'

type Props = {
  showSwitch?: boolean
}

export default function JuzgadoGuardiaSwitch({ showSwitch = false }: Props): JSX.Element {
  const { setFieldValue } = useFormikContext<EscritosFormValues>()

  useEffect(() => {
    setFieldValue(FormField.ORGANO_DESTINO_ENVIAR_JUZGADO_GUARDIA, false, false)
  }, [showSwitch, setFieldValue])

  if (!showSwitch) {
    return <></>
  }

  return (
    <Box sx={{ marginBottom: '16px' }}>
      <SwitchField
        id={FormField.ORGANO_DESTINO_ENVIAR_JUZGADO_GUARDIA}
        label={t('form.field.enviar_juzgado_guardia')}
      />
    </Box>
  )
}
